var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[(_vm.tab_switch == 'contacts')?_c('Contacts',{on:{"tab":_vm.switchTab}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }